import React from 'react'

import { Text } from '@hhgtech/hhg-components/mantine'
import { Calendar, ArrowRight } from '@hhgtech/icons/other'
import { Box } from '@mantine/core'
import { useIntl } from 'react-intl'

import ArrowDown from 'components/atoms/icons/ArrowDown'
import { useIsMobile } from 'hooks/useIsMobile'

import useStyles from './index.styles'
import { BlockItemPropsType } from '..'

const ElegantUI = ({
  icon = <Calendar />,
  title,
  ctaTitle,
  bgColor = 'blue.6',
  className,
  classNames,
  styles,
  iconSize,
  ...boxProps
}: BlockItemPropsType) => {
  const { formatMessage: f } = useIntl()
  const { classes, cx } = useStyles(
    {
      bgColor,
    },
    { name: 'CarePathHeroBannerNavigatorItemElegant', classNames, styles },
  )
  const isMobile = useIsMobile()

  return (
    <Box className={cx(classes.root, className)} {...boxProps}>
      <Box className={classes.wrapper}>
        <Box className={classes.inner}>
          <Box className={classes.infoWrapper}>
            <Box className={classes.thumbnail}>
              {React.cloneElement(icon, {
                size: iconSize || (isMobile ? 40 : 48),
              })}
            </Box>
            {title && (
              <Box className={classes.info}>
                <Text className={classes.title} size={isMobile ? 's2' : 's3'}>
                  {title}
                </Text>
                {!isMobile && (
                  <Box className={classes.exploreLink}>
                    <Text className={classes.exploreText} size="n1">
                      {ctaTitle ||
                        f({
                          id: 'ctaBanner.exploreLink',
                          defaultMessage: 'Explore',
                        })}
                    </Text>
                    <span className={classes.exploreArrow}>
                      <ArrowRight size={16} useCurrentColor />
                    </span>
                  </Box>
                )}
              </Box>
            )}
          </Box>
          {isMobile && (
            <Box className={classes.arrow}>
              <ArrowDown size={20} color={bgColor} />
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  )
}

ElegantUI.displayName = 'ElegantUI'

export { ElegantUI }
